import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bool, shape, string } from 'prop-types';
import * as actions from '~/common/redux/actions';
import Selectors from '~/common/redux/selectors/RemoveCar/ConfirmTransfer';
import NameAndEmailBlock from '~/common/components/NameAndEmailBlock';
import ImageAndInfo from '~/common/components/NewOwnerInformation/ImageAndInfo';
import SubmitButtonWithCheckbox from '~/common/components/ConfirmTransfer/SubmitButtonWithCheckbox';
import links from '~/common/utils/links';

import styles from './styles.module.css';

const ConfirmTransfer = ({
  fullName,
  email,
  confirmTransferTranslations,
  commonTranslations,
  confirmTransferStatus,
  rn,
  isCN,
}) => {
  const history = useHistory();
  const { confirmTransfer, iAmTransferring, cnSpecificObject } = confirmTransferTranslations;
  const { submit } = commonTranslations;
  const { isLoading, isLoaded, error, errorMessage } = confirmTransferStatus;
  const { iAmTransferringCNLine1, iAmTransferringCNLine2 } = cnSpecificObject || '';
  const { REMOVE_CAR_ERROR, REMOVE_CAR_SUCCESS } = links;

  useEffect(() => {
    if (!isLoading && isLoaded && error) {
      history.push({
        pathname: REMOVE_CAR_ERROR,
        search:
          errorMessage === 'JWT_TOKEN_INVALID'
            ? `rn=${rn}&error-status=token-invalid`
            : `rn=${rn}&error-status=general-error`,
      });
    } else if (!isLoading && isLoaded && !error) {
      history.push({
        pathname: REMOVE_CAR_SUCCESS,
        search: `rn=${rn}`,
      });
    }
  }, [isLoading, isLoaded]);

  return (
    <main className={styles.Container} data-test="remove-confirm-transfer">
      <h1 data-test="remove-confirm-transfer-title">{confirmTransfer}</h1>
      <ImageAndInfo dataTestPrefix="remove-confirm-transfer" />
      <div className={styles.NameAndEmailBlock}>
        <NameAndEmailBlock emailValue={email} nameValue={fullName} />
      </div>
      <SubmitButtonWithCheckbox
        iAmTransferring={
          isCN ? (
            <div className={styles.Disclaimer}>
              <div> {iAmTransferringCNLine1}</div>
              <div> {iAmTransferringCNLine2}</div>
            </div>
          ) : (
            iAmTransferring
          )
        }
        submit={submit}
      />
    </main>
  );
};

ConfirmTransfer.propTypes = {
  fullName: string.isRequired,
  email: string.isRequired,
  confirmTransferTranslations: shape({}).isRequired,
  commonTranslations: shape({}).isRequired,
  confirmTransferStatus: shape({
    isLoading: bool,
    isLoaded: bool,
    error: bool,
    errorMessage: string,
  }).isRequired,
  rn: string.isRequired,
  isCN: bool,
};
ConfirmTransfer.defaultProps = { isCN: false };

export default connect(
  Selectors,
  actions
)(ConfirmTransfer);
